import { useRef, useCallback } from 'react'

type DebounceFn<T extends (...args: any[]) => any> = (
  ...args: Parameters<T>
) => void

export function useDebounce<T extends (...args: any[]) => any>(
  fn: T,
  delay: number
): DebounceFn<T> {
  const timer = useRef<NodeJS.Timeout | null>(null)

  const debouncedFn = useCallback(
    (...args: Parameters<T>) => {
      if (timer.current) {
        clearTimeout(timer.current)
      }
      timer.current = setTimeout(() => {
        fn(...args)
      }, delay)
    },
    [fn, delay]
  )

  return debouncedFn
}

export default useDebounce

// const debouncedSearch = useDebounce(search, 1000);
